import Arrow from './renderings/arrow.js'
import BoxArrow from './renderings/box-arrow.js'
import Callout from './renderings/callout.js'
import Chevron from './renderings/chevron.js'
import Cloud from './renderings/cloud.js'
import Cube from './renderings/cube.js'
import DoubleCurvedArrow from './renderings/double-curved-arrow.js'
import Cylinder from './renderings/cylinder.js'
import Diamond from './renderings/diamond.js'
import DoubleArrow from './renderings/double-arrow.js'
import DoubleBoxArrow from './renderings/double-box-arrow.js'
import Ellipse from './renderings/ellipse.js'
import Hexagon from './renderings/hexagon.js'
import Triangle from './renderings/triangle.js'
import LeftCurvedArrow from './renderings/left-curved-arrow.js'
import LeftInwardFoldedArrow from './renderings/left-inward-folded-arrow.js'
import LeftInwardUturnArrow from './renderings/left-inward-uturn-arrow.js'
import LeftOutwardFoldedArrow from './renderings/left-outward-folded-arrow.js'
import LeftOutwardUturnArrow from './renderings/left-outward-uturn-arrow.js'
import LeftParallelogram from './renderings/left-parallelogram.js'
import Line from './renderings/line.js'
import Octagon from './renderings/octagon.js'
import Page from './renderings/page.js'
import Pentagon from './renderings/pentagon.js'
import Plaque from './renderings/plaque.js'
import Plus from './renderings/plus.js'
import QuadArrow from './renderings/quad-arrow.js'
import QuadBoxArrow from './renderings/quad-box-arrow.js'
import Rectangle from './renderings/rectangle.js'
import RightCurvedArrow from './renderings/right-curved-arrow.js'
import RightInwardFoldedArrow from './renderings/right-inward-folded-arrow.js'
import RightInwardUturnArrow from './renderings/right-inward-uturn-arrow.js'
import RightOutwardFoldedArrow from './renderings/right-outward-folded-arrow.js'
import RightOutwardUturnArrow from './renderings/right-outward-uturn-arrow.js'
import RightParallelogram from './renderings/right-parallelogram.js'
import RightTriangle from './renderings/right-triangle.js'
import RoundedRectangle from './renderings/rounded-rectangle.js'
import Seal from './renderings/seal.js'
import Star from './renderings/star.js'
import Tag from './renderings/tag.js'
import Trapezoid from './renderings/trapezoid.js'

export default {
  'arrow': Arrow,
  'box-arrow': BoxArrow,
  'callout': Callout,
  'chevron': Chevron,
  'cloud': Cloud,
  'cube': Cube,
  'cylinder': Cylinder,
  'diamond': Diamond,
  'double-arrow': DoubleArrow,
  'double-box-arrow': DoubleBoxArrow,
  'double-curved-arrow': DoubleCurvedArrow,
  'ellipse': Ellipse,
  'hexagon': Hexagon,
  'triangle': Triangle,
  'left-curved-arrow': LeftCurvedArrow,
  'left-inward-folded-arrow': LeftInwardFoldedArrow,
  'left-inward-uturn-arrow': LeftInwardUturnArrow,
  'left-outward-folded-arrow': LeftOutwardFoldedArrow,
  'left-outward-uturn-arrow': LeftOutwardUturnArrow,
  'left-parallelogram': LeftParallelogram,
  'line': Line,
  'octagon': Octagon,
  'page': Page,
  'pentagon': Pentagon,
  'plaque': Plaque,
  'plus': Plus,
  'quad-arrow': QuadArrow,
  'quad-box-arrow': QuadBoxArrow,
  'rectangle': Rectangle,
  'right-curved-arrow': RightCurvedArrow,
  'right-inward-folded-arrow': RightInwardFoldedArrow,
  'right-inward-uturn-arrow': RightInwardUturnArrow,
  'right-outward-folded-arrow': RightOutwardFoldedArrow,
  'right-outward-uturn-arrow': RightOutwardUturnArrow,
  'right-parallelogram': RightParallelogram,
  'right-triangle': RightTriangle,
  'rounded-rectangle': RoundedRectangle,
  'seal': Seal,
  'star': Star,
  'tag': Tag,
  'trapezoid': Trapezoid,
}
